export default __webpack_public_path__ + "static/media/InsideLungs_11.eca91b92.png";